/**
 * Platform Extensions API
 * 7.35.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from '@oazapfts/runtime';
import * as QS from '@oazapfts/runtime/query';
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
  headers: {},
  baseUrl: '/',
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type ChartDataPoint = {
  date: string;
  critical: number;
  warning: number;
  throughput: number;
};
export type FindingsChartDataViewOutput = {
  chart_data: ChartDataPoint[];
};
export type ListAlertsViewTaskPreview = {
  uuid: string;
  title: string;
  subtitle?: string;
  status: string;
  card_type: string;
  priority: string;
};
export type Alert = {
  accure_id: string;
  full_frontend_id: string;
  system_frontend_id: string;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  /** * `safety` - Safety
   * `imbalance` - Imbalance
   * `soc_offset` - Soc Offset
   * `performance` - Performance
   * `inactivity` - Inactivity
   * `power_availability` - Pcs Power Availability
   * `pcs_efficiency` - Pcs Efficiency
   * `power_capability` - Pcs Power Capability
   * `warranty_condition` - Warranty Condition
   * `warranty_penalty` - Warranty Penalty
   * `warranty_tag` - Warranty Tag
   * `warranty_tag_pcs` - Warranty Tag Pcs
   * `warranty_rte` - Warranty Rte
   * `warranty_soh` - Warranty Soh
   * `no_finding` - No Finding */
  alert_type:
    | 'safety'
    | 'imbalance'
    | 'soc_offset'
    | 'performance'
    | 'inactivity'
    | 'power_availability'
    | 'pcs_efficiency'
    | 'power_capability'
    | 'warranty_condition'
    | 'warranty_penalty'
    | 'warranty_tag'
    | 'warranty_tag_pcs'
    | 'warranty_rte'
    | 'warranty_soh'
    | 'no_finding';
  /** * `Critical` - Critical
   * `Tripped` - Tripped
   * `Warning` - Warning
   * `Info` - Info
   * `OK` - Ok */
  alert_status: 'Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK';
  suggested_action: string;
  status_changed_date: string;
  task?: ListAlertsViewTaskPreview | null;
};
export type ListAlertsViewOutput = {
  alerts: Alert[];
};
export type AlertReset = {
  accure_id: string;
  full_frontend_id: string;
  system_frontend_id: string;
  reset_at_time: string;
};
export type ListAlertResetsViewOutput = {
  alerts_resets: AlertReset[];
};
export type ListNewAlertsTodayViewOutput = {
  alerts: Alert[];
};
export type ListAlertTypesViewOutput = {
  alert_types?: (
    | 'safety'
    | 'imbalance'
    | 'soc_offset'
    | 'performance'
    | 'inactivity'
    | 'power_availability'
    | 'pcs_efficiency'
    | 'power_capability'
    | 'warranty_condition'
    | 'warranty_penalty'
    | 'warranty_tag'
    | 'warranty_tag_pcs'
    | 'warranty_rte'
    | 'warranty_soh'
    | 'no_finding'
  )[];
};
export type NewAlertsItemSerializerV2Request = {
  count: number;
  affected_systems: string[];
  affected_systems_accure_ids: string[];
};
export type SendNotificationViewInputRequest = {
  critical?: NewAlertsItemSerializerV2Request;
  warning?: NewAlertsItemSerializerV2Request;
  info?: NewAlertsItemSerializerV2Request;
};
export type UpdateNotifyConfigViewInputSeralizerRequest = {
  /** * `Critical` - Critical
   * `Tripped` - Tripped
   * `Warning` - Warning
   * `Info` - Info
   * `OK` - Ok */
  minimum_alert_level?: 'Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK';
  site_accure_ids?: string[];
  /** * `Daily` - Daily
   * `NewAlerts` - New Alerts */
  frequency?: 'Daily' | 'NewAlerts';
  recipient_emails?: string[];
  active?: boolean;
};
export type NotifyConfiguration = {
  uuid: string;
  name: string;
  /** * `Critical` - Critical
   * `Tripped` - Tripped
   * `Warning` - Warning
   * `Info` - Info
   * `OK` - Ok */
  minimum_alert_level: 'Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK';
  site_accure_ids: string[];
  /** * `Daily` - Daily
   * `NewAlerts` - New Alerts */
  frequency: 'Daily' | 'NewAlerts';
  recipient_emails: string[];
  active: boolean;
  visible: boolean;
};
export type ListNotifyConfigViewOutput = {
  notify_configs: NotifyConfiguration[];
};
export type CreateNotifyConfigViewInputSeralizerRequest = {
  name: string;
  /** * `Critical` - Critical
   * `Tripped` - Tripped
   * `Warning` - Warning
   * `Info` - Info
   * `OK` - Ok */
  minimum_alert_level: 'Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK';
  /** If list is empty will be interpreted as 'all' */
  site_accure_ids: string[];
  /** * `Daily` - Daily
   * `NewAlerts` - New Alerts */
  frequency: 'Daily' | 'NewAlerts';
  recipient_emails: string[];
  active: boolean;
  visible: boolean;
};
export type SingleAccureIdAlert = {
  accure_id: string;
  full_frontend_id: string;
  score: number;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  alert_type: string;
  alert_status: string;
  suggested_action: string;
  status_changed_date: string;
};
export type ListAlertsSingleAccureIdViewOutput = {
  alerts: SingleAccureIdAlert[];
};
export type ListSingleFindingIdAlertOutput = {
  accure_id: string;
  full_frontend_id: string;
  score: number;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  alert_type: string;
  alert_status: string;
  suggested_action: string;
  status_changed_date: string;
};
export type ListSingleFindingIdViewOutput = {
  alert_infos: ListSingleFindingIdAlertOutput;
};
export type ListJobsViewOutputSerializerJob = {
  uuid: string;
  site_accure_id: string;
  /** * `Pending` - Pending
   * `Completed` - Completed
   * `Failed` - Failed */
  status: 'Pending' | 'Completed' | 'Failed';
  created_at: string;
  charge_start_time: string;
  charge_end_time: string;
  discharge_start_time: string;
  discharge_end_time: string;
  energy: number;
  sohc: number;
};
export type ListJobsViewOutputSerializerJobRead = {
  uuid: string;
  site_accure_id: string;
  /** * `Pending` - Pending
   * `Completed` - Completed
   * `Failed` - Failed */
  status: 'Pending' | 'Completed' | 'Failed';
  created_at: string;
  analysis_date: string;
  charge_start_time: string;
  charge_end_time: string;
  discharge_start_time: string;
  discharge_end_time: string;
  energy: number;
  sohc: number;
};
export type ListJobsViewOutput = {
  jobs: ListJobsViewOutputSerializerJob[];
};
export type ListJobsViewOutputRead = {
  jobs: ListJobsViewOutputSerializerJobRead[];
};
export type GetJobDetailsViewOutput = {
  uuid: string;
  accure_id: string;
  charge_start_time: string;
  charge_end_time: string;
  discharge_start_time: string;
  discharge_end_time: string;
  /** * `Pending` - Pending
   * `Completed` - Completed
   * `Failed` - Failed */
  status: 'Pending' | 'Completed' | 'Failed';
  created_at: string;
  finished_at: string;
};
export type GetJobDetailsViewOutputRead = {
  uuid: string;
  accure_id: string;
  charge_start_time: string;
  charge_end_time: string;
  discharge_start_time: string;
  discharge_end_time: string;
  /** * `Pending` - Pending
   * `Completed` - Completed
   * `Failed` - Failed */
  status: 'Pending' | 'Completed' | 'Failed';
  created_by: string;
  created_at: string;
  finished_at: string;
};
export type JobLevelsViewOutput = {
  levels: string[];
};
export type GetJobResultsViewOutput = {
  accure_id: string;
  full_frontend_id: string;
  charging_energy: number;
  discharging_energy: number;
  charging_soh_c: number;
  discharging_soh_c: number;
};
export type UpdateJobStatusViewInputRequest = {
  /** * `Completed` - Completed
   * `Failed` - Failed */
  status: 'Completed' | 'Failed';
};
export type CreateJobViewInputRequest = {
  accure_id: string;
  charge_start_time: string;
  charge_end_time: string;
  charge_energy?: number;
  charge_power?: number;
  discharge_start_time: string;
  discharge_end_time: string;
  discharge_energy?: number;
  discharge_power?: number;
};
export type CreateJobViewOutputSerizalizer = {
  uuid: string;
};
export type SiteSohViewOutput = {
  year: number;
  month: number;
  avg_soh_c: number;
};
export type SafetyScoreDataViewOutput = {
  date: string;
  accure_id?: string;
  full_frontend_id: string;
  safety_score: number;
};
export type AlertsHistoryDataViewOutput = {
  date: string;
  indicator: string;
  indicator_type: string;
  description: string;
  sensor_ids: string;
  safety_score_impact: string;
};
export type PerformanceAlertsHistoryDataViewOutput = {
  date: string;
  indicator: string;
  indicator_type: string;
  description: string;
  sensor_ids: string;
  safety_score_impact: string;
};
export type SuggestedActionsDataViewOutput = {
  full_frontend_id: string;
  alert_type: string;
  suggested_action: string;
  status_changed_at_date: string;
  latest_data_point: string;
};
export type SocComparisonViewOutput = {
  last_soc_min: number;
  last_soc_max: number;
  last_soc_avg: number;
  full_frontend_id: string;
  accure_id?: string;
};
export type SocSummaryViewOutput = {
  affected_id_or_neighbor: string;
  last_min_accure_soc: number;
  last_max_accure_soc: number;
  accure_soc_imbalance_within_id: number;
  accure_id?: string | null;
};
export type RecommendationsPageDataViewOutput = {
  safety_score: SafetyScoreDataViewOutput[];
  safety_alerts_history: AlertsHistoryDataViewOutput[];
  performance_alerts_history: PerformanceAlertsHistoryDataViewOutput[];
  suggested_actions: SuggestedActionsDataViewOutput[];
  soc_comparison: SocComparisonViewOutput[];
  soc_imbalance_summary: SocSummaryViewOutput[];
};
export type DeviceBase = {
  accure_id: string;
  full_frontend_id: string;
  /** * `system` - system
   * `array` - array
   * `node` - node
   * `container` - container
   * `bank` - bank
   * `pack` - pack
   * `module` - module
   * `cell` - cell */
  level:
    | 'system'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell';
};
export type DeviceDetailsViewOutput = {
  accure_id: string;
  full_frontend_id: string;
  /** * `system` - system
   * `array` - array
   * `node` - node
   * `container` - container
   * `bank` - bank
   * `pack` - pack
   * `module` - module
   * `cell` - cell */
  level:
    | 'system'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell';
  frontend_id?: string;
  lineage?: DeviceBase[];
};
export type DeviceLineageViewOutput = {
  accure_id: string;
  full_frontend_id: string;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
};
export type EmailDetailsViewEmailOutputSerializerSite = {
  accure_id: string;
  name: string;
};
export type EmailDetailsViewEmailOutputSerializerAttachment = {
  file_id: string;
  file_name: string;
  content_type: string;
};
export type EmailDetailsViewEmailOutputSerializerAssociatedMeetingMinutes = {
  uuid: string;
  subject?: string | null;
  content?: string | null;
};
export type EmailDetailsViewEmailOutputSerializerMeetingMetadata = {
  title: string;
  start_time: string;
  end_time: string;
  location: string;
  attendees: string;
};
export type EmailDetailsViewEmailOutput = {
  uuid: string;
  subject?: string;
  sender: string;
  recipients: string;
  cc?: string;
  body?: string;
  date: string;
  /** * `regular` - Regular
   * `meeting` - Meeting */
  type: 'regular' | 'meeting';
  sites?: EmailDetailsViewEmailOutputSerializerSite[];
  attachments?: EmailDetailsViewEmailOutputSerializerAttachment[];
  associated_meeting_minutes?: EmailDetailsViewEmailOutputSerializerAssociatedMeetingMinutes[];
  meeting_metadata?: EmailDetailsViewEmailOutputSerializerMeetingMetadata | null;
};
export type EmailUpdateViewEmailInputRequest = {
  sites_accure_ids: string[];
};
export type ListEmailsViewEmailOutputSerializerAssociatedMeetingMinutes = {
  uuid: string;
  subject?: string | null;
  content?: string | null;
  date?: string | null;
  updated_at?: string | null;
  email_uuid?: string | null;
  author?: string | null;
};
export type ListEmailsViewEmailOutputSerializerMeetingMetadata = {
  title?: string | null;
  start_time: string;
  end_time: string;
  location?: string | null;
  attendees?: string | null;
};
export type ListEmailsViewEmailOutput = {
  uuid: string;
  subject?: string;
  sender: string;
  recipients?: string;
  cc?: string;
  body?: string;
  date: string;
  /** * `regular` - Regular
   * `meeting` - Meeting */
  type: 'regular' | 'meeting';
  sites?: number[];
  attachments?: Record<string, any>[];
  associated_meeting_minutes?: ListEmailsViewEmailOutputSerializerAssociatedMeetingMinutes[];
  meeting_metadata?: ListEmailsViewEmailOutputSerializerMeetingMetadata | null;
};
export type ListEmailsViewOutput = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ListEmailsViewEmailOutput[];
};
export type DetailsMeetingMinutesViewMeetingMinutesOutput = {
  uuid: string;
  subject: string;
  content: string;
  date: string;
  updated_at: string;
  author: string;
  email_uuid?: string;
  email_subject?: string;
};
export type UpdateMeetingMinutesViewMeetingMinutesInputRequest = {
  subject?: string;
  content?: string;
  email_id?: string;
};
export type CreateMeetingMinutesViewMeetingMinutesInputRequest = {
  subject?: string;
  content: string;
  email_id: string;
};
export type CreateMeetingMinutesViewMeetingMinutesOutput = {
  uuid: string;
};
export type ListIdViewOutput = {
  ids: string[];
};
export type ListLevelsViewOutput = {
  levels: string[];
};
export type CustomerTypeViewOutput = {
  customer_type: string;
};
export type SiteDynamicData = {
  accure_id: string;
  /** * `Landscape` - System
   * `BESS` - Container
   * `String` - String
   * `Rack` - Rack
   * `Module` - Module
   * `PCS` - Pcs */
  battery_level: 'Landscape' | 'BESS' | 'String' | 'Rack' | 'Module' | 'PCS';
  frontend_unit_id: string;
  full_frontend_id: string;
  accure_soc?: number;
  bms_soc?: number;
  soc_offset?: number;
  imbalance_soc?: number;
  imbalance_soc_date?: string;
  temperature?: number;
  throughput?: number;
  /** * `Critical` - Critical
   * `Tripped` - Tripped
   * `Warning` - Warning
   * `Info` - Info
   * `OK` - Ok */
  alert_status?:
    | ('Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK' | null)
    | null;
  nb_open_tasks?: number;
  capacity?: number;
  cell_type?: string;
  manufacturer?: string;
  cell_chemistry?: string;
  device_type?: string;
};
export type SiteDynamicdataViewOutput = {
  dynamic_data: SiteDynamicData[];
};
export type Landscape = {
  background_image_satellite?: string;
  background_image_abstract?: string;
};
export type TextureSet = {
  front?: string;
  back?: string;
  left?: string;
  right?: string;
  top?: string;
};
export type BackgroundSerializerr = {
  skybox?: TextureSet;
  sphere_skybox?: string;
  color?: string;
  image?: string;
};
export type Dimensions3D = {
  width: number;
  height: number;
  depth?: number;
};
export type SpecificationsDimensions = {
  Landscape: Dimensions3D;
  BESS: Dimensions3D;
  String?: Dimensions3D;
  PCS?: Dimensions3D;
  Rack?: Dimensions3D;
};
export type SpecificationsTexture = {
  BESS?: TextureSet;
  PCS?: TextureSet;
};
export type Specifications = {
  dimensions: SpecificationsDimensions;
  textures?: SpecificationsTexture;
};
export type PositionOrRotation3D = {
  x: number;
  y: number;
  z: number;
};
export type Positionable = {
  uid: string;
  label: string;
  frontend_unit_id: string;
  full_frontend_id: string;
  position: PositionOrRotation3D;
  rotation: PositionOrRotation3D;
  dimensions_override?: Dimensions3D;
};
export type Container = {
  uid: string;
  label: string;
  frontend_unit_id: string;
  full_frontend_id: string;
  position: PositionOrRotation3D;
  rotation: PositionOrRotation3D;
  dimensions_override?: Dimensions3D;
  rack_strings?: Positionable[];
  racks?: Positionable[];
  modules?: Positionable[];
  texture_override?: TextureSet;
  doors?: Positionable[];
  vents?: Record<string, any>[];
};
export type Pcs = {
  uid: string;
  label: string;
  frontend_unit_id: string;
  full_frontend_id: string;
  position: PositionOrRotation3D;
  rotation: PositionOrRotation3D;
  dimensions_override?: Dimensions3D;
  texture_override?: TextureSet;
  doors?: Positionable[];
};
export type Connection = {
  uid: string;
  pcs: string;
  containers: string[];
  diameter_override?: number;
};
export type SiteStaticdataViewOutput = {
  landscape?: Landscape;
  background?: BackgroundSerializerr;
  specifications: Specifications;
  containers?: Container[];
  pcs?: Pcs[];
  connections?: Connection[];
};
export type UpdateSiteViewInputRequest = {
  picture?: Blob;
  latitude?: number;
  longitude?: number;
  address?: string;
  installation_date?: string;
  commissioning_date?: string;
  /** * `Planning` - Planning
   * `Commissioning` - Commissioning
   * `In Operation` - In Operation
   * `Monitoring Ended` - Monitoring Ended
   * `End Of Life` - End Of Life */
  operational_phase?:
    | 'Planning'
    | 'Commissioning'
    | 'In Operation'
    | 'Monitoring Ended'
    | 'End Of Life';
  nominal_power_w?: number;
  nominal_energy_wh?: number;
};
export type SiteListViewOutputSerializerSiteSerializerAlerts = {
  critical?: number;
  warning?: number;
};
export type Site = {
  accure_id: string;
  name: string;
  full_frontend_id: string;
  latitude: number;
  longitude: number;
  nominal_power_w?: number;
  nominal_energy_wh?: number;
  cell_type?: string;
  missing_docs_count: number;
  alerts: SiteListViewOutputSerializerSiteSerializerAlerts;
  open_cards_count: number;
  /** * `Planning` - Planning
   * `Commissioning` - Commissioning
   * `In Operation` - In Operation
   * `Monitoring Ended` - Monitoring Ended
   * `End Of Life` - End Of Life */
  operational_phase:
    | 'Planning'
    | 'Commissioning'
    | 'In Operation'
    | 'Monitoring Ended'
    | 'End Of Life';
};
export type Sites = {
  sites: Site[];
};
export type SiteListBasicViewSite = {
  sites: Site[];
};
export type SitesListContractInfoViewOutputSerializerContractInfoSite = {
  site_accure_id: string;
  site_name: string;
  contract_start_date?: string;
  contract_end_date?: string;
  bolt_tier?: string;
};
export type SitesListContractInfoViewOutput = {
  sites_contract_info: SitesListContractInfoViewOutputSerializerContractInfoSite[];
};
export type CreateSiteViewInputRequest = {
  name: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  installation_date?: string;
  commissioning_date?: string;
  /** * `Planning` - Planning
   * `Commissioning` - Commissioning
   * `In Operation` - In Operation
   * `Monitoring Ended` - Monitoring Ended
   * `End Of Life` - End Of Life */
  operational_phase?:
    | 'Planning'
    | 'Commissioning'
    | 'In Operation'
    | 'Monitoring Ended'
    | 'End Of Life';
  nominal_power_w?: number | null;
  nominal_energy_wh?: number | null;
  picture?: Blob;
  accure_id?: string | null;
};
export type CreateSiteViewOutput = {
  accure_id: string;
};
export type NewSiteCandidate = {
  name: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  installation_date?: string;
  commissioning_date?: string;
  /** * `Planning` - Planning
   * `Commissioning` - Commissioning
   * `In Operation` - In Operation
   * `Monitoring Ended` - Monitoring Ended
   * `End Of Life` - End Of Life */
  operational_phase?:
    | 'Planning'
    | 'Commissioning'
    | 'In Operation'
    | 'Monitoring Ended'
    | 'End Of Life';
  nominal_power_w?: number | null;
  nominal_energy_wh?: number | null;
  picture?: string;
  accure_id: string;
};
export type NewSiteCandidates = {
  sites: NewSiteCandidate[];
};
export type VehiclesListViewVehicle = {
  accure_id: string;
  full_frontend_id: string;
};
export type VehiclesListViewOutput = {
  vehicles: VehiclesListViewVehicle[];
};
export type SiteDetailV2ViewOutputSerializerAlerts = {
  critical?: number;
  warning?: number;
};
export type SiteDetailViewOutputSerializerUnitStatusTrippedUnits = {
  frontend_id: string;
  since: string;
};
export type SiteDetailViewOutputSerializerUnitStatus = {
  operational: number;
  tripped: SiteDetailViewOutputSerializerUnitStatusTrippedUnits[];
};
export type GetSiteDetailV2ViewOutput = {
  accure_id: string;
  name: string;
  full_frontend_id: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  installation_date?: string;
  commissioning_date?: string;
  /** * `Planning` - Planning
   * `Commissioning` - Commissioning
   * `In Operation` - In Operation
   * `Monitoring Ended` - Monitoring Ended
   * `End Of Life` - End Of Life */
  operational_phase:
    | 'Planning'
    | 'Commissioning'
    | 'In Operation'
    | 'Monitoring Ended'
    | 'End Of Life';
  nominal_power_w?: number;
  nominal_energy_wh?: number;
  cell_type?: string;
  picture?: string;
  alerts: SiteDetailV2ViewOutputSerializerAlerts;
  open_cards_count: number;
  unit_status: SiteDetailViewOutputSerializerUnitStatus;
};
export type File = {
  file_id: string;
  parent_id: string;
  parent_entity: string;
  uploaded_at: string;
};
export type FileRead = {
  file_id: string;
  parent_id: string;
  parent_entity: string;
  uploaded_at: string;
  file_name: string;
  file_extension: string;
};
export type FilesListOutput = {
  files: File[];
};
export type FilesListOutputRead = {
  files: FileRead[];
};
export type FileUploadRequest = {
  files?: Blob[];
};
export type HealthCheckViewOutput = {
  status: string;
};
export type MaintenanceBackupViewOutput = {
  status: string;
};
export type ChangelogViewOutput = {
  changelog: string[];
};
export type MetricsViewOutputSerializerRequestCountMetric = {
  api_path: string;
  count: number;
  date: string;
  status_code: number;
  user_email: string;
};
export type MetricsViewOutputSerializerLatencyMetric = {
  api_path: string;
  latency: number;
  timestamp: string;
  status_code: number;
  user_email: string;
};
export type MetricsViewOutputSerializerUptimeMetric = {
  state: string;
  created_at: string;
};
export type MetricsViewOutput = {
  request_count: MetricsViewOutputSerializerRequestCountMetric[];
  latency: MetricsViewOutputSerializerLatencyMetric[];
  uptime: MetricsViewOutputSerializerUptimeMetric[];
};
export type PlatformStatusViewOutputComponentDayDowntime = {
  error_class: string;
  duration_sec: number;
};
export type PlatformStatusViewOutputComponentDay = {
  date: string;
  downtimes: PlatformStatusViewOutputComponentDayDowntime[];
};
export type PlatformStatusViewOutputComponent = {
  id: string;
  component_name: string;
  description: string | null;
  active_error_class: string | null;
  uptime: number;
  days: PlatformStatusViewOutputComponentDay[];
};
export type PlatformStatusViewOutput = {
  active_error_class: string | null;
  platform_components: PlatformStatusViewOutputComponent[];
};
export type VersionViewOutput = {
  version: string;
};
export type Details = {
  field: string;
};
export type DetailsRead = {
  field: string;
  old: string;
  new: string;
};
export type Activity = {
  uuid: string;
  document_uuid: string;
  document_name: string;
  document_visible: boolean;
  document_type: string;
  /** * `Create` - Create
   * `Update` - Update
   * `Delete` - Delete */
  category: 'Create' | 'Update' | 'Delete';
  details: Details;
  user_name: string;
  sites_accure_ids: string[];
  timestamp: string;
  seen: boolean;
};
export type ActivityRead = {
  uuid: string;
  document_uuid: string;
  document_name: string;
  document_visible: boolean;
  document_type: string;
  /** * `Create` - Create
   * `Update` - Update
   * `Delete` - Delete */
  category: 'Create' | 'Update' | 'Delete';
  details: DetailsRead;
  user_name: string;
  sites_accure_ids: string[];
  timestamp: string;
  seen: boolean;
};
export type ListActivitiesViewOutput = {
  activities: Activity[];
};
export type ListActivitiesViewOutputRead = {
  activities: ActivityRead[];
};
export type ActivitySeenViewInputRequest = {
  /** List of UUIDs of the activities to be marked as seen */
  uuids: string[];
};
export type DocumentSendEmailViewInputRequest = {
  recipient_emails: string[];
};
export type DocumentUpdateViewInputRequest = {
  new_file_name?: string;
  new_tags?: string[];
  /** * `Specifications` - Specifications
   * `Presentations` - Presentations
   * `Reports` - Reports
   * `Other` - Other */
  new_type?: 'Specifications' | 'Presentations' | 'Reports' | 'Other';
  new_sites_accure_ids?: string[];
};
export type DocumentListViewOutputSerializerTag = {
  title: string;
};
export type SiteDocumentList = {
  accure_id: string;
  name: string;
};
export type DocumentListViewOutputSerializerDocument = {
  uuid: string;
  file: File;
  required: boolean;
  name: string;
  /** * `Specifications` - Specifications
   * `Presentations` - Presentations
   * `Reports` - Reports
   * `Other` - Other */
  type: 'Specifications' | 'Presentations' | 'Reports' | 'Other';
  created_at: string;
  modified_at: string;
  tags: DocumentListViewOutputSerializerTag[];
  sites: SiteDocumentList[];
  is_global: boolean;
};
export type DocumentListViewOutputSerializerDocumentRead = {
  uuid: string;
  file: FileRead;
  required: boolean;
  name: string;
  /** * `Specifications` - Specifications
   * `Presentations` - Presentations
   * `Reports` - Reports
   * `Other` - Other */
  type: 'Specifications' | 'Presentations' | 'Reports' | 'Other';
  created_at: string;
  created_by: string;
  modified_at: string;
  tags: DocumentListViewOutputSerializerTag[];
  sites: SiteDocumentList[];
  is_global: boolean;
};
export type DocumentListViewOutputSerializerMissingDocuments = {
  name: string;
  /** * `Specifications` - Specifications
   * `Presentations` - Presentations
   * `Reports` - Reports
   * `Other` - Other */
  type: 'Specifications' | 'Presentations' | 'Reports' | 'Other';
  tags: string[];
  sites: SiteDocumentList[];
};
export type DocumentListViewOutput = {
  documents: DocumentListViewOutputSerializerDocument[];
  missing?: DocumentListViewOutputSerializerMissingDocuments[];
};
export type DocumentListViewOutputRead = {
  documents: DocumentListViewOutputSerializerDocumentRead[];
  missing?: DocumentListViewOutputSerializerMissingDocuments[];
};
export type DocumentUploadViewInputRequest = {
  file: Blob;
  name?: string;
  tags?: string[];
  /** * `Specifications` - Specifications
   * `Presentations` - Presentations
   * `Reports` - Reports
   * `Other` - Other */
  type?: 'Specifications' | 'Presentations' | 'Reports' | 'Other';
  sites_accure_ids?: string[];
  is_global?: boolean;
};
export type ClearSystemLogsCacheViewOutput = {
  success: boolean;
  message: string;
};
export type ListFiltersViewOutputSerializerFilter = {
  id: string;
  order?: number;
  label: string;
  values: Record<string, any>[];
  active: boolean;
};
export type ListFiltersViewOutput = {
  site?: ListFiltersViewOutputSerializerFilter;
  start_date?: ListFiltersViewOutputSerializerFilter;
  end_date?: ListFiltersViewOutputSerializerFilter;
  domain?: ListFiltersViewOutputSerializerFilter;
  array?: ListFiltersViewOutputSerializerFilter;
  node?: ListFiltersViewOutputSerializerFilter;
  container?: ListFiltersViewOutputSerializerFilter;
  bank?: ListFiltersViewOutputSerializerFilter;
  pack?: ListFiltersViewOutputSerializerFilter;
  module?: ListFiltersViewOutputSerializerFilter;
  cell?: ListFiltersViewOutputSerializerFilter;
  pcs?: ListFiltersViewOutputSerializerFilter;
};
export type ListSystemLogsViewColumn = {
  id: string;
  label: string;
  /** * `string` - string
   * `number` - number
   * `datetime` - datetime
   * `boolean` - boolean
   * `integer` - integer
   * `float` - float */
  type: 'string' | 'number' | 'datetime' | 'boolean' | 'integer' | 'float';
  /** * `text` - text
   * `integer` - integer
   * `decimal` - decimal
   * `datetime` - datetime
   * `duration` - duration */
  format: 'text' | 'integer' | 'decimal' | 'datetime' | 'duration';
};
export type ListSystemLogsViewRow = {
  id: string;
  cells: Record<string, any>;
};
export type ListSystemLogsViewOutputSerializerData = {
  columns: ListSystemLogsViewColumn[];
  rows: ListSystemLogsViewRow[];
};
export type ListSystemLogsViewOutput = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ListSystemLogsViewOutputSerializerData;
};
export type User = {
  name: string;
  email: string;
  company?: string;
  guest_user: boolean;
  default_landing_page?: string;
};
export type GetCardDetailViewOutputCard = {
  uuid: string;
  title: string;
  subtitle?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  /** * `Standard` - Standard
   * `Alert` - Alert
   * `DataOnboardingIncident` - Do Incident */
  card_type: 'Standard' | 'Alert' | 'DataOnboardingIncident';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
  description?: string;
  assignee?: User;
  created_at: string;
  created_by: User;
  due_date?: string;
  modified_at: string;
};
export type GetCardDetailViewOutputDevice = {
  accure_id?: string;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level?:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  cell_type?: string;
  unit_type?: string;
  full_frontend_id?: string;
  frontend_level?: string;
  frontend_site_id?: string;
  frontend_top_id?: string;
  frontend_unit_id?: string;
  site_accure_id?: string;
};
export type GetCardDetailViewOutputAlertInfos = {
  status: string;
  suggested_action: string;
  status_changed_date: string;
  alert_type: string;
  resolved: boolean;
};
export type GetCardDetailViewOutputModificationHistory = {
  modified_at: string;
  modified_by: User;
  column: string;
  value: string;
};
export type GetCardDetailViewOutputComment = {
  uuid: string;
  content: string;
  created_at: string;
  modified: boolean;
  modified_at?: string;
};
export type GetCardDetailViewOutputCommentRead = {
  uuid: string;
  content: string;
  user_name: string;
  user_email: string;
  created_at: string;
  modified: boolean;
  modified_at?: string;
};
export type GetCardDetailViewOutputCardCustomField = {
  name: string;
  value: any;
};
export type GetCardDetailViewOutputWorkstream = {
  uuid: string;
  name: string;
};
export type GetCardDetailViewOutputProject = {
  accure_id: string;
  name: string;
};
export type GetCardDetailViewOutputWorkstreamProjectDetails = {
  workstream?: GetCardDetailViewOutputWorkstream;
  project?: GetCardDetailViewOutputProject;
};
export type GetCardDetailViewOutput = {
  card: GetCardDetailViewOutputCard;
  device?: GetCardDetailViewOutputDevice;
  alert_infos?: GetCardDetailViewOutputAlertInfos;
  modification_history: GetCardDetailViewOutputModificationHistory[];
  comments: GetCardDetailViewOutputComment[];
  score_reset: boolean;
  custom_fields?: GetCardDetailViewOutputCardCustomField[];
  is_subscribed: boolean;
  workstream_project_details?: GetCardDetailViewOutputWorkstreamProjectDetails;
};
export type GetCardDetailViewOutputRead = {
  card: GetCardDetailViewOutputCard;
  device?: GetCardDetailViewOutputDevice;
  alert_infos?: GetCardDetailViewOutputAlertInfos;
  modification_history: GetCardDetailViewOutputModificationHistory[];
  comments: GetCardDetailViewOutputCommentRead[];
  score_reset: boolean;
  custom_fields?: GetCardDetailViewOutputCardCustomField[];
  is_subscribed: boolean;
  workstream_project_details?: GetCardDetailViewOutputWorkstreamProjectDetails;
};
export type CardSendEmailViewInputRequest = {
  recipient_emails: string[];
};
export type ResetScoreViewInputRequest = {
  /** * `maintenance` - maintenance
   * `recalibration` - recalibration
   * `replacement` - replacement
   * `other` - other */
  reason: 'maintenance' | 'recalibration' | 'replacement' | 'other';
  description?: string;
};
export type UpdateCardViewInputRequest = {
  title?: string;
  subtitle?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status?: 'Open' | 'In Progress' | 'External Review' | 'Done' | '';
  description?: string;
  due_date?: string | null;
  /** * `Standard` - Standard
   * `Alert` - Alert
   * `DataOnboardingIncident` - Do Incident */
  card_type?: 'Standard' | 'Alert' | 'DataOnboardingIncident' | '';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority?: 'Low' | 'Medium' | 'High' | '';
  frontend_id?: string;
  frontend_level?: string;
  assignee_name?: string;
  assignee_email?: string;
  assignee_company?: string;
  closed_at?: string;
};
export type UpdateCardViewOutput = {
  uuid: string;
  title: string;
  subtitle?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  /** * `Standard` - Standard
   * `Alert` - Alert
   * `DataOnboardingIncident` - Do Incident */
  card_type: 'Standard' | 'Alert' | 'DataOnboardingIncident';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
  assignee?: User;
};
export type CardArchived = {
  uuid: string;
  title: string;
};
export type CleanUpDoneViewOutput = {
  archived: CardArchived[];
};
export type ListCardsViewOutputWorkstream = {
  uuid: string;
  name: string;
};
export type ListCardsViewOutputProject = {
  accure_id: string;
  name: string;
};
export type ListCardsViewOutputWorkstreamProjectDetails = {
  workstream?: ListCardsViewOutputWorkstream;
  project?: ListCardsViewOutputProject;
};
export type ListCardsViewOutputExistingCards = {
  uuid: string;
  title: string;
  subtitle?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  /** * `Standard` - Standard
   * `Alert` - Alert
   * `DataOnboardingIncident` - Do Incident */
  card_type: 'Standard' | 'Alert' | 'DataOnboardingIncident';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
  alert_type?: string;
  alert_status?: string;
  suggested_action?: string;
  resolved?: boolean;
  archived: boolean;
  workstream_project_details?: ListCardsViewOutputWorkstreamProjectDetails;
};
export type ListCardsViewOutputSuggestions = {
  accure_id: string;
  frontend_id: string;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  alert_type: string;
  status: string;
  suggested_action: string;
  status_changed_date: string;
  finding_id: string;
};
export type ListCardsViewOutput = {
  existing_cards: ListCardsViewOutputExistingCards[];
  suggestions: ListCardsViewOutputSuggestions[];
};
export type CardCustomFieldRequest = {
  name: string;
  value: any;
};
export type CreateCardViewInputRequest = {
  title: string;
  subtitle?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  description?: string;
  due_date?: string;
  /** * `Standard` - Standard
   * `Alert` - Alert
   * `DataOnboardingIncident` - Do Incident */
  card_type: 'Standard' | 'Alert' | 'DataOnboardingIncident';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
  finding_id?: string;
  accure_id?: string;
  /** * `system` - System
   * `pcs` - Pcs
   * `array` - Array
   * `node` - Node
   * `container` - Container
   * `bank` - Bank
   * `pack` - Pack
   * `module` - Module
   * `cell` - Cell
   * `` - Empty */
  level?:
    | 'system'
    | 'pcs'
    | 'array'
    | 'node'
    | 'container'
    | 'bank'
    | 'pack'
    | 'module'
    | 'cell'
    | '';
  custom_fields?: CardCustomFieldRequest[];
  workstream_uuid?: string;
  assignee_name?: string;
  assignee_email?: string;
  assignee_company?: string;
};
export type CreateCardViewOutputSerizalizer = {
  uuid: string;
};
export type UpdateCommentViewInputRequest = {
  content: string;
};
export type CreateCommentViewInputRequest = {
  card_uuid: string;
  content: string;
};
export type CreateCommentViewOutputSerizalizer = {
  uuid: string;
};
export type ResetScoreConfirmationEmailViewInputRequest = {
  accure_ids: string[];
  reset_date?: string;
};
export type ListPredefinedWorkstreamTemplatesViewOutput = {
  name: string;
  description: string;
  number_of_tasks: number;
};
export type AttachCardToWorkstreamViewInputRequest = {
  card_uuid: string;
};
export type AttachCardToWorkstreamViewOutput = {
  workstream_uuid: string;
  card_uuid: string;
};
export type DeleteWorkstreamViewOutput = {
  uuid: string;
  site_accure_id: string;
};
export type GetWorkstreamViewOutputSerializerProject = {
  accure_id: string;
  name: string;
};
export type GetWorkstreamViewOutputSerializerCard = {
  uuid: string;
  title: string;
  description?: string;
  due_date?: string | null;
  assignee?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
};
export type GetWorkstreamViewOutput = {
  uuid: string;
  name: string;
  description: string;
  project: GetWorkstreamViewOutputSerializerProject;
  start_date: string;
  end_date: string;
  responsible: string;
  responsible_name: string;
  responsible_email: string;
  progress: number;
  cards: GetWorkstreamViewOutputSerializerCard[];
};
export type UpdateWorkstreamViewInputRequest = {
  name?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  responsible_name?: string;
  responsible_email?: string;
  responsible_company?: string;
};
export type ListWorkstreamsViewOutputSerializerProject = {
  accure_id: string;
  name: string;
};
export type ListWorkstreamsViewOutputSerializerCard = {
  uuid: string;
  title: string;
  description?: string;
  due_date?: string | null;
  assignee?: string;
  /** * `Open` - Open
   * `In Progress` - In Progress
   * `External Review` - External Review
   * `Done` - Done */
  status: 'Open' | 'In Progress' | 'External Review' | 'Done';
  /** * `Low` - Low
   * `Medium` - Medium
   * `High` - High */
  priority: 'Low' | 'Medium' | 'High';
};
export type ListWorkstreamsViewOutput = {
  uuid: string;
  name: string;
  description?: string;
  project: ListWorkstreamsViewOutputSerializerProject;
  start_date: string;
  end_date: string;
  responsible: string;
  responsible_name: string;
  responsible_email: string;
  progress: number;
  cards: ListWorkstreamsViewOutputSerializerCard[];
};
export type CreateWorkstreamViewInputRequest = {
  name: string;
  description?: string;
  site_accure_id: string;
  start_date: string;
  end_date?: string;
  template_name?: string;
  responsible_name?: string;
  responsible_email?: string;
  responsible_company?: string;
};
export type CreateWorkstreamViewOutput = {
  uuid: string;
};
export type PatchedUpdateUserPreferencesInputRequest = {
  default_landing_page?: string;
  first_name?: string;
  last_name?: string;
};
export type AuthUser = {
  uuid: string;
  first_name: string;
  last_name: string;
  default_landing_page: string;
};
export type CreateAuth0UserRequest = {
  first_name: string;
  last_name: string;
  email: string;
  /** * `third-party` - Third Party
   * `customer` - Customer
   * `admin` - Admin */
  user_role: 'third-party' | 'customer' | 'admin';
  all_sites_access?: boolean;
  sites_access_list?: string[];
  is_active?: boolean;
};
export type CreateAuth0UserOutput = {
  uuid: string;
};
export type DeleteAuth0UserOutput = {
  success: boolean;
  message: string;
};
export type UserRole = {
  id: string;
  name: string;
};
export type AuthUserListItem = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
  role: UserRole;
};
export type AuthUserListItemRead = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
  role: UserRole;
  last_login_at: string;
};
export type ListAuthUsersOutput = {
  users: AuthUserListItem[];
};
export type ListAuthUsersOutputRead = {
  users: AuthUserListItemRead[];
};
export type ListAllUsersViewOutput = {
  users: User[];
};
export type ListLookerUsersViewOutput = {
  looker_users: User[];
};
export type MeViewOutput = {
  uuid: string;
  first_name: string;
  last_name: string;
  email: string;
  is_mfa_active: boolean;
  default_landing_page: string;
  sites_access_list: Record<string, any>[];
  is_internal: boolean;
  white_label: boolean;
};
export type RequestMfaEnrollmentTicketOutput = {
  enrollment_ticket_url: string;
};
export type RemoveMfaEnrollmentOutput = {
  success: boolean;
  message: string;
};
export type CreateUserInputRequest = {
  name: string;
  email: string;
  company: string;
};
export type RequestPasswordResetOutput = {
  password_reset_url: string;
};
export type DeleteRoleOutput = {
  success: boolean;
  message: string;
};
export type PatchedUpdateRoleInputRequest = {
  name?: string;
  /** * `third-party` - Third Party
   * `customer` - Customer
   * `admin` - Admin */
  permissions?: 'third-party' | 'customer' | 'admin';
  all_sites?: boolean;
  sites_access_list?: string[];
};
export type Role = {
  uuid: string;
  name: string;
  user_role: string;
  all_sites_access: boolean;
  created_at: string;
  last_updated_at: string;
};
export type RoleRead = {
  uuid: string;
  name: string;
  user_role: string;
  all_sites_access: boolean;
  sites_access_list: string;
  created_at: string;
  last_updated_at: string;
};
export type CreateRoleInputRequest = {
  name: string;
  /** * `third-party` - Third Party
   * `customer` - Customer
   * `admin` - Admin */
  permissions: 'third-party' | 'customer' | 'admin';
  all_sites: boolean;
  sites_access_list: string[];
};
export type CreateRoleOutput = {
  uuid: string;
  name: string;
};
export type ListRolesOutput = {
  roles: Role[];
};
export type ListRolesOutputRead = {
  roles: RoleRead[];
};
export type WarrantyPenaltiesOutput = {
  displayed_id: string;
  timestamp?: string;
  penalty: number | null;
  reason?: string;
  metrics?: Record<string, any>;
  soh_warranty?: number | null;
  total_throughput?: number | null;
  total_cycles?: number | null;
};
export type WarrantyPenaltiesViewOutput = {
  data: WarrantyPenaltiesOutput[];
};
export type WarrantyStatus = {
  displayed_id: string;
  coverage_issues: string[];
  compliance_issues: string[];
  coverage_status: string;
  compliance_status: string;
  total_throughput: number | null;
  total_cycles: number | null;
  total_age: number | null;
  penalty: number | null;
  soh_warranty: number | null;
  soh_accure: number | null;
};
export type WarrantyStatusViewOutput = {
  data: WarrantyStatus[];
};
export type TimeseriesPoint = {
  timestamp: string;
  value: number | null;
};
export type MetricData = {
  metric_name: string;
  data: TimeseriesPoint[];
  unit: string;
};
export type TimeseriesOutput = {
  timeseries: MetricData[];
};
export type WarrantyViolationsOutput = {
  displayed_id: string;
  timestamp?: string;
  violations?: Record<string, string[]>;
  coverage_issues?: string[];
  compliance_issues?: string[];
  coverage_status?: string;
  compliance_status?: string;
};
export type WarrantyViolationsViewOutput = {
  data: WarrantyViolationsOutput[];
};
export type UnitOverviewColumnConfig = {
  column: string;
  order: number;
  title?: string | null;
  tooltip?: string | null;
};
export type GuaranteedValue = {
  base: number;
  penalty: number;
  effective: number;
};
export type UnitOverviewRow = {
  id: string;
  frontend_id: string;
  /** * `No Data` - No Data
   * `Valid` - Valid
   * `Case Open` - Case Open
   * `Expired` - Expired */
  coverage_status?:
    | ('No Data' | 'Valid' | 'Case Open' | 'Expired' | null)
    | null;
  /** * `No Data` - No Data
   * `Compliant` - Compliant
   * `Non-Compliant` - Non-Compliant
   * `At Risk` - At Risk
   * `Non-Compliant and At Risk` - Non-Compliant and At Risk */
  compliance_status?:
    | (
        | 'No Data'
        | 'Compliant'
        | 'Non-Compliant'
        | 'At Risk'
        | 'Non-Compliant and At Risk'
        | null
      )
    | null;
  suggested_action?: string;
  age_in_years?: number;
  cycles_total?: number | null;
  throughput_total?: number | null;
  avg_container_tag?: number;
  avg_pcs_tag?: number;
  soh?: number;
  guaranteed_soh?: GuaranteedValue;
};
export type UnitOverview = {
  columns: UnitOverviewColumnConfig[];
  rows: UnitOverviewRow[];
};
export type WarrantyPenaltyCurrent = {
  last_detected_at: string | null;
  penalty: number;
  extreme_value: number;
  extreme_value_unit: string;
  duration_hours: number | null;
  count: number | null;
};
export type WarrantyPenaltyPrediction = {
  applies_at: string;
  penalty_delta: number;
};
export type WarrantyPenalty = {
  id: string;
  description: string;
  current?: WarrantyPenaltyCurrent | null;
  prediction?: WarrantyPenaltyPrediction | null;
};
export type ConditionViolationHistoryPoint = {
  date: string;
  affected_units: number;
};
export type ConditionViolationHistorySeries = {
  points: ConditionViolationHistoryPoint[];
};
export type ConditionViolation = {
  id: string;
  description: string;
  extreme_value: number;
  extreme_value_unit: string;
  last_detected_at: string;
  duration_hours: number;
  affected_units_count: number;
  history_series: ConditionViolationHistorySeries;
};
export type WarrantyDataViewOutput = {
  unit_overview?: UnitOverview;
  warranty_penalties: WarrantyPenalty[];
  condition_violations: ConditionViolation[];
};
export type IdFilterInstance = {
  id: string;
  label: string;
};
export type WarrantyIdFilter = {
  id: string;
  order: number;
  label: string;
  values: IdFilterInstance[];
};
export type WarrantyIdLevel = {
  array?: WarrantyIdFilter;
  node?: WarrantyIdFilter;
  container?: WarrantyIdFilter;
  bank?: WarrantyIdFilter;
  pack?: WarrantyIdFilter;
  module?: WarrantyIdFilter;
};
export type ListWarrantyFiltersViewOutput = {
  filters: WarrantyIdLevel;
};
export type MetricsPoint = {
  date: string;
  value: number;
};
export type MetricsSeries = {
  points: MetricsPoint[];
};
export type Metric = {
  id: string;
  name: string;
  description?: string | null;
  order: number;
  value: number;
  guaranteed_value?: GuaranteedValue;
  caped_ld?: number | null;
  value_series?: MetricsSeries | null;
  caped_ld_series?: MetricsSeries | null;
};
export type MetricsGroup = {
  id: string;
  name: string;
  order: number;
  metrics: Metric[];
  caped_ld?: number | null;
};
export type MetricsOutput = {
  start?: string | null;
  end?: string | null;
  currency: string;
  groups: MetricsGroup[] | null;
};
/**
 * Get findings chart data for time-series visualization over specified period
 */
export function alertsV1FindingsThroughputPerDayRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    daysRange,
    includePcsAlerts,
    includeWarrantyAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    daysRange: number;
    includePcsAlerts: boolean;
    includeWarrantyAlerts: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: FindingsChartDataViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/alerts/v1/findings-throughput-per-day${QS.query(
      QS.explode({
        days_range: daysRange,
        include_pcs_alerts: includePcsAlerts,
        include_warranty_alerts: includeWarrantyAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get alert overview
 */
export function alertsV1ListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    alertStatusList,
    alertTypes,
    changedSinceDays,
    customerType,
    frontendGroupIds,
    includePcsAlerts,
    includeTask,
    includeWarrantyAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    alertStatusList?: ('Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK')[];
    alertTypes?: (
      | 'safety'
      | 'imbalance'
      | 'soc_offset'
      | 'performance'
      | 'inactivity'
      | 'power_availability'
      | 'pcs_efficiency'
      | 'power_capability'
      | 'warranty_condition'
      | 'warranty_penalty'
      | 'warranty_tag'
      | 'warranty_tag_pcs'
      | 'warranty_rte'
      | 'warranty_soh'
      | 'no_finding'
    )[];
    changedSinceDays?: number;
    customerType: 'bess' | 'hss' | 'mobility';
    frontendGroupIds?: string[];
    includePcsAlerts?: boolean;
    includeTask?: boolean;
    includeWarrantyAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListAlertsViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/alerts/v1/list${QS.query(
      QS.explode({
        alert_status_list: alertStatusList,
        alert_types: alertTypes,
        changed_since_days: changedSinceDays,
        customer_type: customerType,
        frontend_group_ids: frontendGroupIds,
        include_pcs_alerts: includePcsAlerts,
        include_task: includeTask,
        include_warranty_alerts: includeWarrantyAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get alert resets overview
 */
export function alertsV1ListAlertResetsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    changedSinceDays,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    changedSinceDays?: number;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListAlertResetsViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/alerts/v1/list-alert-resets${QS.query(
      QS.explode({
        changed_since_days: changedSinceDays,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get only new alerts from today
 */
export function alertsV1ListNewTodayRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    alertStatusList,
    alertTypes,
    customerType,
    frontendGroupIds,
    includePcsAlerts,
    includeWarrantyAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    alertStatusList?: ('Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK')[];
    alertTypes?: (
      | 'safety'
      | 'imbalance'
      | 'soc_offset'
      | 'performance'
      | 'inactivity'
      | 'power_availability'
      | 'pcs_efficiency'
      | 'power_capability'
      | 'warranty_condition'
      | 'warranty_penalty'
      | 'warranty_tag'
      | 'warranty_tag_pcs'
      | 'warranty_rte'
      | 'warranty_soh'
      | 'no_finding'
    )[];
    customerType: 'bess' | 'hss' | 'mobility';
    frontendGroupIds?: string[];
    includePcsAlerts?: boolean;
    includeWarrantyAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListNewAlertsTodayViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/alerts/v1/list-new-today${QS.query(
      QS.explode({
        alert_status_list: alertStatusList,
        alert_types: alertTypes,
        customer_type: customerType,
        frontend_group_ids: frontendGroupIds,
        include_pcs_alerts: includePcsAlerts,
        include_warranty_alerts: includeWarrantyAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * List all alert types
 */
export function alertsV1ListAlertTypesRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    includePcsAlerts,
    includeWarrantyAlerts,
    socOffsetViaVoltage,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    includePcsAlerts?: boolean;
    includeWarrantyAlerts?: boolean;
    socOffsetViaVoltage?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListAlertTypesViewOutput;
      }
    | {
        status: 500;
      }
  >(
    `/alerts/v1/list/alert-types${QS.query(
      QS.explode({
        include_pcs_alerts: includePcsAlerts,
        include_warranty_alerts: includeWarrantyAlerts,
        soc_offset_via_voltage: socOffsetViaVoltage,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Send alert notifications
 */
export function alertsV1NotifyCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    sendNotificationViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    sendNotificationViewInputRequest?: SendNotificationViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 424;
      }
  >(
    '/alerts/v1/notify',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: sendNotificationViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Soft delete a notification configuration by name
 */
export function alertsV1NotifyConfigsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/alerts/v1/notify/configs/${encodeURIComponent(uuid)}/delete`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Update an existing notification configuration
 */
export function alertsV1NotifyConfigsUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateNotifyConfigViewInputSeralizerRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateNotifyConfigViewInputSeralizerRequest?: UpdateNotifyConfigViewInputSeralizerRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/alerts/v1/notify/configs/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: updateNotifyConfigViewInputSeralizerRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List all visible notification configurations
 */
export function alertsV1NotifyConfigsListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListNotifyConfigViewOutput;
      }
    | {
        status: 500;
      }
  >('/alerts/v1/notify/configs/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Create a new notification configuration
 */
export function alertsV1NotifyConfigsNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createNotifyConfigViewInputSeralizerRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createNotifyConfigViewInputSeralizerRequest: CreateNotifyConfigViewInputSeralizerRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    '/alerts/v1/notify/configs/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createNotifyConfigViewInputSeralizerRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Get all alerts for single accure id
 */
export function alertsV1SingleListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    customerType,
    includePcsAlerts,
    includeWarrantyAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    customerType: 'bess' | 'hss' | 'mobility';
    includePcsAlerts?: boolean;
    includeWarrantyAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListAlertsSingleAccureIdViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/alerts/v1/single/${encodeURIComponent(accureId)}/list${QS.query(
      QS.explode({
        customer_type: customerType,
        include_pcs_alerts: includePcsAlerts,
        include_warranty_alerts: includeWarrantyAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get all alerts for single accure id
 */
export function alertsV1SingleListRetrieve2(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    customerType,
    findingId,
    includePcsAlerts,
    includeWarrantyAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    customerType: 'bess' | 'hss' | 'mobility';
    findingId: string;
    includePcsAlerts?: boolean;
    includeWarrantyAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListSingleFindingIdViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/alerts/v1/single/${encodeURIComponent(findingId)}/list${QS.query(
      QS.explode({
        customer_type: customerType,
        include_pcs_alerts: includePcsAlerts,
        include_warranty_alerts: includeWarrantyAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * List all capacity evaluation jobs
 */
export function capacityEvaluationV1JobListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    siteAccureId,
    statusType,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    siteAccureId: string;
    statusType?: 'Completed' | 'Failed' | 'Pending';
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: ListJobsViewOutputRead;
  }>(
    `/capacity_evaluation/v1/job/${encodeURIComponent(siteAccureId)}/list${QS.query(
      QS.explode({
        status_type: statusType,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Retrieve capacity evaluation job details
 */
export function capacityEvaluationV1JobDetailsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: GetJobDetailsViewOutputRead;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >(`/capacity_evaluation/v1/job/${encodeURIComponent(uuid)}/details`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get unique levels for a given capacity evaluation job
 */
export function capacityEvaluationV1JobLevelsRetrieve(
  {
    uuid,
  }: {
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: JobLevelsViewOutput;
  }>(`/capacity_evaluation/v1/job/${encodeURIComponent(uuid)}/levels`, {
    ...opts,
  });
}
/**
 * Retrieve capacity evaluation job results
 */
export function capacityEvaluationV1JobResultsList(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    level,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    level: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: GetJobResultsViewOutput[];
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >(
    `/capacity_evaluation/v1/job/${encodeURIComponent(uuid)}/results${QS.query(
      QS.explode({
        level,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Update capacity evaluation job status
 */
export function capacityEvaluationV1JobUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateJobStatusViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateJobStatusViewInputRequest: UpdateJobStatusViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/capacity_evaluation/v1/job/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: updateJobStatusViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Create a new capacity evaluation
 */
export function capacityEvaluationV1JobNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createJobViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createJobViewInputRequest: CreateJobViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateJobViewOutputSerizalizer;
      }
    | {
        status: 400;
      }
    | {
        status: 500;
      }
  >(
    '/capacity_evaluation/v1/job/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createJobViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Read site SOH values
 */
export function capacityEvaluationV1SiteSohList(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: SiteSohViewOutput[];
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >(`/capacity_evaluation/v1/site/${encodeURIComponent(accureId)}/soh`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get ACCURE SOC distribution data for units
 */
export function commonV1DataAccureSocDailyRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/accure-soc-daily${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get ACCURE SOC distribution data for units
 */
export function commonV1DataAccureSocDistributionRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/accure-soc-distribution${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get BMS SOC daily data for units
 */
export function commonV1DataBmsSocDailyRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bms-soc-daily${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get BMS SOC distribution data for units
 */
export function commonV1DataBmsSocDistributionRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bms-soc-distribution${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get everything for benchmark page
 */
export function commonV1DataBundlesBenchmarkRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bundles/benchmark${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get health data for benchmark page
 */
export function commonV1DataBundlesBenchmarkHealthRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bundles/benchmark-health${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get aggregated unit stats including SOH average, energy with units, cycles, uptime, temperature and SOC averages over the last 30 days
 */
export function commonV1DataBundlesBenchmarkOverviewRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bundles/benchmark-overview${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get performance data for benchmark page
 */
export function commonV1DataBundlesBenchmarkPerformanceRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/bundles/benchmark-performance${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get everything for recommendations page
 */
export function commonV1DataBundlesRecommendationsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: RecommendationsPageDataViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 500;
      }
  >(
    `/common/v1/data/bundles/recommendations${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get charging throughput data for units
 */
export function commonV1DataChargingCRateRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/charging-c-rate${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get daily data availability data for units
 */
export function commonV1DataDailyDataAvailabilityRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/daily-data-availability${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get daily temperature data for units
 */
export function commonV1DataDailyTemperatureRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/daily-temperature${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get daily throughput data for units
 */
export function commonV1DataDailyThroughputRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/daily-throughput${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get discharging throughput data for units
 */
export function commonV1DataDischargingCRateRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/discharging-c-rate${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get monthly SOHc values grouped by system, window_end_date, and age_in_years
 */
export function commonV1DataMonthlySohCRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/monthly-soh-c${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get performance alerts history data for a unit
 */
export function commonV1DataPerformanceAlertsHistoryRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/performance-alerts-history${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get safety score data for a unit
 */
export function commonV1DataSafetyAlertsHistoryRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/safety-alerts-history${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get safety score data for a unit
 */
export function commonV1DataSafetyScoreRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    accureIdOutput,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    accureIdOutput?: boolean;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/safety-score${QS.query(
      QS.explode({
        accure_id: accureId,
        accure_id_output: accureIdOutput,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get SOC summary data for a unit
 */
export function commonV1DataSocAndImbalanceSummaryRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    accureIdOutput,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    accureIdOutput?: boolean;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soc-and-imbalance-summary${QS.query(
      QS.explode({
        accure_id: accureId,
        accure_id_output: accureIdOutput,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get SOC comparison data for a unit
 */
export function commonV1DataSocComparisonRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    accureIdOutput,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    accureIdOutput?: boolean;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soc-comparison${QS.query(
      QS.explode({
        accure_id: accureId,
        accure_id_output: accureIdOutput,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get difference SOC daily data for units
 */
export function commonV1DataSocOffsetDailyRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soc-offset-daily${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get ACCURE SOC distribution data for units
 */
export function commonV1DataSocOffsetDistributionRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soc-offset-distribution${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get time spent in SOC state data for units
 */
export function commonV1DataSocTimeSpentInStateRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soc-time-spent-in-state${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get SOH-C distribution data for units
 */
export function commonV1DataSohCDistributionRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/soh-c-distribution${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get SOH-C distribution benachmark page data
 */
export function commonV1DataSohCDistributionBenchmarkPageRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    '/common/v1/data/soh-c-distribution-benchmark-page',
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get suggested actions data for a unit
 */
export function commonV1DataSuggestedActionsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    fullFrontendId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/suggested-actions${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get temperature distribution data for units
 */
export function commonV1DataTemperatureDistributionRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    fullFrontendId,
    timeWindow,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId?: string[];
    fullFrontendId?: string[];
    timeWindow: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/common/v1/data/temperature-distribution${QS.query(
      QS.explode({
        accure_id: accureId,
        full_frontend_id: fullFrontendId,
        time_window: timeWindow,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get device details including lineage
 */
export function commonV1DeviceDetailsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DeviceDetailsViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 500;
      }
  >(`/common/v1/device/${encodeURIComponent(accureId)}/details`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Returns devices with the given level from the device's lineage. Returns 404 if the level doesn't exist in the device's lineage structure. Returns empty list if level exists but no devices found at that level. This endpoint is only available for BESS customers.
 */
export function commonV1DeviceLineageList(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    level,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    level:
      | 'array'
      | 'bank'
      | 'cell'
      | 'container'
      | 'module'
      | 'node'
      | 'pack'
      | 'system';
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DeviceLineageViewOutput[];
      }
    | {
        status: 404;
      }
    | {
        status: 405;
      }
    | {
        status: 500;
      }
  >(
    `/common/v1/device/${encodeURIComponent(accureId)}/lineage/${encodeURIComponent(level)}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Download an email attachment
 */
export function communicationV1EmailsAttachmentsDownloadRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 404;
      }
  >(
    `/communication/v1/emails-attachments/${encodeURIComponent(fileId)}/download`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Delete an email and its associated S3 object
 */
export function communicationV1EmailsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/communication/v1/emails/${encodeURIComponent(uuid)}/delete`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get email details
 */
export function communicationV1EmailsDetailsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: EmailDetailsViewEmailOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 500;
      }
  >(`/communication/v1/emails/${encodeURIComponent(uuid)}/details`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Link email to sites
 */
export function communicationV1EmailsUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    emailUpdateViewEmailInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    emailUpdateViewEmailInputRequest: EmailUpdateViewEmailInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/communication/v1/emails/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: emailUpdateViewEmailInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Get a combined and paginated list of emails and meeting minutes.
 */
export function communicationV1EmailsListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    limit,
    offset,
    search,
    sitesAccureIds,
    $type,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    limit: number;
    offset?: number;
    search?: string;
    sitesAccureIds?: string[];
    $type?: 'meeting' | 'regular';
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListEmailsViewOutput;
      }
    | {
        status: 500;
      }
  >(
    `/communication/v1/emails/list${QS.query(
      QS.explode({
        limit,
        offset,
        search,
        sites_accure_ids: sitesAccureIds,
        type: $type,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Endpoint to handle SNS notifications
 */
export function communicationV1EmailsSnsTriggerCreate(
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/communication/v1/emails/sns-trigger', {
    ...opts,
    method: 'POST',
  });
}
/**
 * Sync all emails
 */
export function communicationV1EmailsSyncCreate(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchText('/communication/v1/emails/sync', {
    ...opts,
    method: 'POST',
  });
}
/**
 * delete meeting minutes
 */
export function communicationV1MeetingMinutesDeleteUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/communication/v1/meeting-minutes/${encodeURIComponent(uuid)}/delete`,
    {
      ...opts,
      method: 'PUT',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get meeting minutes details
 */
export function communicationV1MeetingMinutesDetailsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DetailsMeetingMinutesViewMeetingMinutesOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 500;
      }
  >(`/communication/v1/meeting-minutes/${encodeURIComponent(uuid)}/details`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * update meeting minutes
 */
export function communicationV1MeetingMinutesUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateMeetingMinutesViewMeetingMinutesInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateMeetingMinutesViewMeetingMinutesInputRequest?: UpdateMeetingMinutesViewMeetingMinutesInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/communication/v1/meeting-minutes/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: updateMeetingMinutesViewMeetingMinutesInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * create a meeting minutes
 */
export function communicationV1MeetingMinutesNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createMeetingMinutesViewMeetingMinutesInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createMeetingMinutesViewMeetingMinutesInputRequest: CreateMeetingMinutesViewMeetingMinutesInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateMeetingMinutesViewMeetingMinutesOutput;
      }
    | {
        status: 400;
      }
  >(
    '/communication/v1/meeting-minutes/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createMeetingMinutesViewMeetingMinutesInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List IDs
 */
export function customerInfosV1CustomerIdsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    level,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    level: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListIdViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/customer_infos/v1/customer-ids/${QS.query(
      QS.explode({
        level,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * List Battery Levels for a customer or specific site
 */
export function customerInfosV1CustomerLevelsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    siteAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    siteAccureId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListLevelsViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/customer_infos/v1/customer-levels/${QS.query(
      QS.explode({
        site_accure_id: siteAccureId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Return the customer type as stored in the external customer_info table
 */
export function customerInfosV1CustomerTypeRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: CustomerTypeViewOutput;
  }>('/customer_infos/v1/customer-type/', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get site dynamic data
 */
export function customerInfosV1SitesDynamicDataRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    queryDate,
    visualizationBatteryLevels,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    queryDate?: string;
    visualizationBatteryLevels?: (
      | 'BESS'
      | 'Module'
      | 'PCS'
      | 'Rack'
      | 'String'
    )[];
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: SiteDynamicdataViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(
    `/customer_infos/v1/sites/${encodeURIComponent(accureId)}/dynamic-data${QS.query(
      QS.explode({
        query_date: queryDate,
        visualization_battery_levels: visualizationBatteryLevels,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get site metadata
 */
export function customerInfosV1SitesMetadataRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: {
          /** The section name (e.g., 'system', 'array') */
          section?: string;
          contents?: {
            /** Name of the attribute */
            attribute_name?: string;
            /** Value of the attribute */
            value?: string;
            /** Format of the attribute value */
            format?:
              | 'watt'
              | 'watt_hour'
              | 'watt_hour'
              | 'ampere_hour'
              | 'celsius'
              | 'percent'
              | 'date'
              | 'date';
            source?: {
              /** Name of the document source */
              name?: string;
              /** Value of the document UUID */
              uuid?: string;
            };
          }[][];
        }[];
      }
    | {
        status: 404;
      }
  >(`/customer_infos/v1/sites/${encodeURIComponent(accureId)}/metadata`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get site static data
 */
export function customerInfosV1SitesStaticDataRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: SiteStaticdataViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(`/customer_infos/v1/sites/${encodeURIComponent(accureId)}/static-data`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Update a site
 */
export function customerInfosV1SitesUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    updateSiteViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    updateSiteViewInputRequest?: UpdateSiteViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/customer_infos/v1/sites/${encodeURIComponent(accureId)}/update`,
    oazapfts.multipart({
      ...opts,
      method: 'PUT',
      body: updateSiteViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Retrieve list of sites.
 */
export function customerInfosV1SitesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    includePcsAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    includePcsAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: Sites;
  }>(
    `/customer_infos/v1/sites/list${QS.query(
      QS.explode({
        include_pcs_alerts: includePcsAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Retrieve basic list of sites.
 */
export function customerInfosV1SitesListBasicRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: SiteListBasicViewSite;
  }>('/customer_infos/v1/sites/list-basic', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * List available contract information for all customer sites
 */
export function customerInfosV1SitesListContractInfoRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: SitesListContractInfoViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >('/customer_infos/v1/sites/list-contract-info/', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Create a new site
 */
export function customerInfosV1SitesNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    publish,
    createSiteViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    publish?: boolean;
    createSiteViewInputRequest: CreateSiteViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateSiteViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/customer_infos/v1/sites/new${QS.query(
      QS.explode({
        publish,
      }),
    )}`,
    oazapfts.multipart({
      ...opts,
      method: 'POST',
      body: createSiteViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Retrieve list of sites that are onboarded in data onboarding system but not yet added to platform. These are candidates for creating new sites.
 */
export function customerInfosV1SitesNewCandidatesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: NewSiteCandidates;
  }>('/customer_infos/v1/sites/new-candidates/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get text
 */
export function customerInfosV1TextRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    context,
    html,
    section,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    context: string;
    html?: boolean;
    section: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/customer_infos/v1/text${QS.query(
      QS.explode({
        context,
        html,
        section,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get accure and frontend id for a vehicle.
 */
export function customerInfosV1VehicleAccureIdRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    frontendId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    frontendId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/customer_infos/v1/vehicle/${encodeURIComponent(frontendId)}/accure-id`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * List all vehicles from platform_frontend_id_mapping where show_on_frontend=True and unit_level='system'
 */
export function customerInfosV1VehiclesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: VehiclesListViewOutput;
      }
    | {
        status: 500;
      }
  >('/customer_infos/v1/vehicles/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get site details
 */
export function customerInfosV2SitesDetailRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureId,
    includePcsAlerts,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureId: string;
    includePcsAlerts?: boolean;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: GetSiteDetailV2ViewOutput;
      }
    | {
        status: 404;
      }
  >(
    `/customer_infos/v2/sites/${encodeURIComponent(accureId)}/detail${QS.query(
      QS.explode({
        include_pcs_alerts: includePcsAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get quickstart guide document
 */
export function documentationV1QuickstartGuideRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    customerType,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    customerType: 'bess' | 'hss' | 'mobility';
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 404;
      }
  >(
    `/documentation/v1/quickstart-guide${QS.query(
      QS.explode({
        customer_type: customerType,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Delete file
 */
export function globalFilesDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/global-files/${encodeURIComponent(fileId)}/delete`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Download file
 */
export function globalFilesDownloadRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 403;
      }
    | {
        status: 404;
      }
  >(`/global-files/${encodeURIComponent(fileId)}/download`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Retrieve list of files.
 */
export function globalFilesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: FilesListOutputRead;
      }
    | {
        status: 422;
      }
  >('/global-files/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Upload a file
 */
export function globalFilesUploadCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileUploadRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileUploadRequest?: FileUploadRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    '/global-files/upload',
    oazapfts.multipart({
      ...opts,
      method: 'POST',
      body: fileUploadRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Perform health check
 */
export function maintenanceHealthRetrieve(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchJson<{
    status: 200;
    data: HealthCheckViewOutput;
  }>('/maintenance/health', {
    ...opts,
  });
}
/**
 * Perform database backup
 */
export function maintenanceV1BackupRetrieve(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: MaintenanceBackupViewOutput;
      }
    | {
        status: 500;
        data: MaintenanceBackupViewOutput;
      }
  >('/maintenance/v1/backup', {
    ...opts,
  });
}
/**
 * Show changelog
 */
export function maintenanceV1ChangelogRetrieve(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchJson<{
    status: 200;
    data: ChangelogViewOutput;
  }>('/maintenance/v1/changelog', {
    ...opts,
  });
}
/**
 * Get aggregated metrics for request count, latency, and uptime
 */
export function maintenanceV1MetricsRetrieve(
  {
    endDate,
    startDate,
  }: {
    endDate?: string;
    startDate?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: MetricsViewOutput;
      }
    | {
        status: 400;
      }
  >(
    `/maintenance/v1/metrics${QS.query(
      QS.explode({
        end_date: endDate,
        start_date: startDate,
      }),
    )}`,
    {
      ...opts,
    },
  );
}
/**
 * Get platform status with uptime calculations
 */
export function maintenanceV1PlatformStatusRetrieve(
  {
    daysRange,
  }: {
    daysRange?: number;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: PlatformStatusViewOutput;
      }
    | {
        status: 400;
      }
  >(
    `/maintenance/v1/platform-status${QS.query(
      QS.explode({
        days_range: daysRange,
      }),
    )}`,
    {
      ...opts,
    },
  );
}
/**
 * Get API version
 */
export function maintenanceVersionRetrieve(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchJson<{
    status: 200;
    data: VersionViewOutput;
  }>('/maintenance/version', {
    ...opts,
  });
}
/**
 * Send platform status update mail
 */
export function mixedV1PlatformStatusUpdateMailCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/mixed/v1/platform-status-update-mail', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Reset Demo Dashboard
 */
export function mixedV1ResetCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/mixed/v1/reset', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get data for ROI calculation
 */
export function mixedV1RoiDataRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    lastNMonths,
    lastYear,
    recipients,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    lastNMonths?: number;
    lastYear?: boolean;
    recipients?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/mixed/v1/roi-data${QS.query(
      QS.explode({
        last_n_months: lastNMonths,
        last_year: lastYear,
        recipients,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Sentry alert webhook → GitLab issue creation
 */
export function monitoringV1SentryWebhookCreate(opts?: Oazapfts.RequestOpts) {
  return oazapfts.fetchText('/monitoring/v1/sentry-webhook', {
    ...opts,
    method: 'POST',
  });
}
/**
 * Retrieve list of activities
 */
export function recordsV1ActivitiesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    activityCategory,
    dateThreshold,
    documentType,
    siteAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    activityCategory?: ('Create' | 'Update' | 'Delete')[];
    dateThreshold?: string;
    documentType?: ('Specifications' | 'Presentations' | 'Reports' | 'Other')[];
    siteAccureId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: ListActivitiesViewOutputRead;
  }>(
    `/records/v1/activities/list${QS.query(
      QS.explode({
        activity_category: activityCategory,
        date_threshold: dateThreshold,
        document_type: documentType,
        site_accure_id: siteAccureId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Mark multiple activities as seen for a particular user.
 */
export function recordsV1ActivitiesSeenUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    activitySeenViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    activitySeenViewInputRequest: ActivitySeenViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
        data: {
          /** The error message describing the server issue. */
          error?: string;
        };
      }
  >(
    '/records/v1/activities/seen',
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: activitySeenViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Delete document
 */
export function recordsV1DocumentsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/records/v1/documents/${encodeURIComponent(uuid)}/delete`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Download document
 */
export function recordsV1DocumentsDownloadRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 404;
      }
  >(`/records/v1/documents/${encodeURIComponent(uuid)}/download`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Send document via an email
 */
export function recordsV1DocumentsEmailCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    documentSendEmailViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    documentSendEmailViewInputRequest: DocumentSendEmailViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 424;
      }
  >(
    `/records/v1/documents/${encodeURIComponent(uuid)}/email`,
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: documentSendEmailViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Update document
 */
export function recordsV1DocumentsUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    documentUpdateViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    documentUpdateViewInputRequest?: DocumentUpdateViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/records/v1/documents/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: documentUpdateViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List of documents for list of sites or for all sites
 */
export function recordsV1DocumentsListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    isGlobal,
    sitesAccureIds,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    isGlobal?: boolean;
    sitesAccureIds?: string[];
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: DocumentListViewOutputRead;
  }>(
    `/records/v1/documents/list${QS.query(
      QS.explode({
        is_global: isGlobal,
        sites_accure_ids: sitesAccureIds,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Upload document, to one or more or all sites.Either is_global or sites_accure_ids must be provided.
 */
export function recordsV1DocumentsUploadCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    documentUploadViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    documentUploadViewInputRequest: DocumentUploadViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
        data: {
          /** The error message describing the server issue. */
          error?: string;
        };
      }
  >(
    '/records/v1/documents/upload',
    oazapfts.multipart({
      ...opts,
      method: 'POST',
      body: documentUploadViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Generate operational report for all sites
 */
export function recordsV1OperationalReportCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/records/v1/operational-report', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Generate operational report for single site
 */
export function recordsV1OperationalReportCreate2(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    siteAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    siteAccureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/records/v1/operational-report/${encodeURIComponent(siteAccureId)}`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Generate portfilio report
 */
export function recordsV1PortfolioReportCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/records/v1/portfolio-report', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Generate warranty report for all sites
 */
export function recordsV1WarrantyReportCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/records/v1/warranty-report', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Generate warranty report for single site
 */
export function recordsV1WarrantyReportCreate2(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    siteAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    siteAccureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/records/v1/warranty-report/${encodeURIComponent(siteAccureId)}`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Generate insurance report for all sites
 */
export function recordsV2InsuranceReportCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/records/v2/insurance-report', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Generate insurance report for single site
 */
export function recordsV2InsuranceReportCreate2(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    siteAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    siteAccureId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/records/v2/insurance-report/${encodeURIComponent(siteAccureId)}`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Clear system logs cache.
 */
export function systemLogsV1CacheClearCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ClearSystemLogsCacheViewOutput;
      }
    | {
        status: 500;
      }
  >('/system-logs/v1/cache/clear', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * List filters.
 */
export function systemLogsV1FiltersListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    domain,
    siteAccureId,
    unitAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    domain?: 'battery' | 'other' | 'pcs';
    siteAccureId?: string;
    unitAccureId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListFiltersViewOutput;
      }
    | {
        status: 500;
      }
  >(
    `/system-logs/v1/filters/list${QS.query(
      QS.explode({
        domain,
        site_accure_id: siteAccureId,
        unit_accure_id: unitAccureId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * List system logs.
 */
export function systemLogsV1LogsListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    accureLevel,
    domain,
    endDate,
    limit,
    offset,
    siteAccureId,
    startDate,
    $type,
    unitAccureId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    accureLevel?:
      | 'array'
      | 'bank'
      | 'cell'
      | 'container'
      | 'module'
      | 'node'
      | 'pack'
      | 'pcs'
      | 'system';
    domain?: 'battery' | 'other' | 'pcs';
    endDate?: string;
    limit?: number;
    offset?: number;
    siteAccureId?: string;
    startDate?: string;
    $type?: string;
    unitAccureId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListSystemLogsViewOutput;
      }
    | {
        status: 424;
      }
    | {
        status: 500;
      }
  >(
    `/system-logs/v1/logs/list${QS.query(
      QS.explode({
        accure_level: accureLevel,
        domain,
        end_date: endDate,
        limit,
        offset,
        site_accure_id: siteAccureId,
        start_date: startDate,
        type: $type,
        unit_accure_id: unitAccureId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Contact ACCURE through Asana
 */
export function tasksV1CardsContactCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/contact`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Delete a card, preferred delete method
 */
export function tasksV1CardsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 204;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(`/tasks/v1/cards/${encodeURIComponent(uuid)}/delete`, {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Detach a card from its workstream
 */
export function tasksV1CardsDetachFromWorkstreamDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/detach-from-workstream`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get card details
 */
export function tasksV1CardsDetailRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    customerType,
    includePcsAlerts,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    customerType: 'bess' | 'hss' | 'mobility';
    includePcsAlerts?: boolean;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: GetCardDetailViewOutputRead;
      }
    | {
        status: 403;
      }
    | {
        status: 404;
      }
  >(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/detail${QS.query(
      QS.explode({
        customer_type: customerType,
        include_pcs_alerts: includePcsAlerts,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Send card details as an email
 */
export function tasksV1CardsEmailCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    cardSendEmailViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    cardSendEmailViewInputRequest: CardSendEmailViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 403;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 424;
      }
  >(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/email`,
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: cardSendEmailViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Delete file
 */
export function tasksV1CardsFilesDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileId,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileId: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/files/${encodeURIComponent(fileId)}/delete`,
    {
      ...opts,
      method: 'DELETE',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Download file
 */
export function tasksV1CardsFilesDownloadRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    fileId,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    fileId: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 403;
      }
    | {
        status: 404;
      }
  >(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/files/${encodeURIComponent(fileId)}/download`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Retrieve list of files.
 */
export function tasksV1CardsFilesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: FilesListOutputRead;
      }
    | {
        status: 422;
      }
  >(`/tasks/v1/cards/${encodeURIComponent(uuid)}/files/list`, {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Upload a file
 */
export function tasksV1CardsFilesUploadCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    fileUploadRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    fileUploadRequest?: FileUploadRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/files/upload`,
    oazapfts.multipart({
      ...opts,
      method: 'POST',
      body: fileUploadRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Reset score through Asana
 */
export function tasksV1CardsResetScoreCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    resetScoreViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    resetScoreViewInputRequest: ResetScoreViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/reset-score`,
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: resetScoreViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Subscribe to task updates
 */
export function tasksV1CardsSubscribeCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/subscribe`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Unsubscribe from task updates
 */
export function tasksV1CardsUnsubscribeCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/unsubscribe`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Update a card
 */
export function tasksV1CardsUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateCardViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateCardViewInputRequest?: UpdateCardViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: UpdateCardViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/tasks/v1/cards/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: updateCardViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Clean up done column
 */
export function tasksV1CardsCleanUpDoneUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: CleanUpDoneViewOutput;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >('/tasks/v1/cards/clean-up-done', {
    ...opts,
    method: 'PUT',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * list cards overview
 */
export function tasksV1CardsListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    alertStatus,
    alertStatusList,
    alertTypesList,
    archived,
    assigneeEmail,
    cardType,
    customerType,
    frontendId,
    includePcsAlerts,
    includeWorkstreamsCards,
    priority,
    workstreamUuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    alertStatus?: 'Critical' | 'Info' | 'OK' | 'Tripped' | 'Warning';
    alertStatusList?: ('Critical' | 'Tripped' | 'Warning' | 'Info' | 'OK')[];
    alertTypesList?: (
      | 'safety'
      | 'imbalance'
      | 'soc_offset'
      | 'performance'
      | 'inactivity'
      | 'power_availability'
      | 'pcs_efficiency'
      | 'power_capability'
      | 'warranty_condition'
      | 'warranty_penalty'
      | 'warranty_tag'
      | 'warranty_tag_pcs'
      | 'warranty_rte'
      | 'warranty_soh'
      | 'no_finding'
    )[];
    archived?: boolean;
    assigneeEmail?: string;
    cardType?: 'Alert' | 'DataOnboardingIncident' | 'Standard';
    customerType: 'bess' | 'hss' | 'mobility';
    frontendId?: string;
    includePcsAlerts?: boolean;
    includeWorkstreamsCards?: boolean;
    priority?: 'High' | 'Low' | 'Medium';
    workstreamUuid?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListCardsViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/tasks/v1/cards/list${QS.query(
      QS.explode({
        alert_status: alertStatus,
        alert_status_list: alertStatusList,
        alert_types_list: alertTypesList,
        archived,
        assignee_email: assigneeEmail,
        card_type: cardType,
        customer_type: customerType,
        frontend_id: frontendId,
        include_pcs_alerts: includePcsAlerts,
        include_workstreams_cards: includeWorkstreamsCards,
        priority,
        workstream_uuid: workstreamUuid,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Create a new card
 */
export function tasksV1CardsNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createCardViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createCardViewInputRequest: CreateCardViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateCardViewOutputSerizalizer;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    '/tasks/v1/cards/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createCardViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Delete a comment
 */
export function tasksV1CommentsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 204;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(`/tasks/v1/comments/${encodeURIComponent(uuid)}/delete`, {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Update a comment
 */
export function tasksV1CommentsUpdateCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateCommentViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateCommentViewInputRequest: UpdateCommentViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 204;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
  >(
    `/tasks/v1/comments/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: updateCommentViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Create a new comment
 */
export function tasksV1CommentsNewCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createCommentViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createCommentViewInputRequest: CreateCommentViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateCommentViewOutputSerizalizer;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 424;
      }
  >(
    '/tasks/v1/comments/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createCommentViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Export done column
 */
export function tasksV1ExportDoneRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/tasks/v1/export-done', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Send reset score confirmation via an email
 */
export function tasksV1ResetScoreConfirmationEmailCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    resetScoreConfirmationEmailViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    resetScoreConfirmationEmailViewInputRequest: ResetScoreConfirmationEmailViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 424;
      }
  >(
    '/tasks/v1/reset-score-confirmation-email',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: resetScoreConfirmationEmailViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List all predefined workstream templates with task counts and descriptions
 */
export function tasksV1WorkstreamTemplatesListList(
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListPredefinedWorkstreamTemplatesViewOutput[];
      }
    | {
        status: 500;
      }
  >('/tasks/v1/workstream-templates/list', {
    ...opts,
  });
}
/**
 * Attach a card to a workstream
 */
export function tasksV1WorkstreamsAttachCardCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    attachCardToWorkstreamViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    attachCardToWorkstreamViewInputRequest: AttachCardToWorkstreamViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: AttachCardToWorkstreamViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(
    `/tasks/v1/workstreams/${encodeURIComponent(uuid)}/attach-card`,
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: attachCardToWorkstreamViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Delete a workstream
 */
export function tasksV1WorkstreamsDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DeleteWorkstreamViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(`/tasks/v1/workstreams/${encodeURIComponent(uuid)}/delete`, {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Retrieve a workstream by UUID
 */
export function tasksV1WorkstreamsDetailsRetrieve(
  {
    uuid,
  }: {
    uuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: GetWorkstreamViewOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 500;
      }
  >(`/tasks/v1/workstreams/${encodeURIComponent(uuid)}/details`, {
    ...opts,
  });
}
/**
 * Update a workstream
 */
export function tasksV1WorkstreamsUpdateUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    uuid,
    updateWorkstreamViewInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    uuid: string;
    updateWorkstreamViewInputRequest?: UpdateWorkstreamViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/tasks/v1/workstreams/${encodeURIComponent(uuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: updateWorkstreamViewInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List all workstreams, optionally filtered by site_accure_id
 */
export function tasksV1WorkstreamsListList(
  {
    siteAccureId,
  }: {
    siteAccureId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListWorkstreamsViewOutput[];
      }
    | {
        status: 400;
      }
    | {
        status: 500;
      }
  >(
    `/tasks/v1/workstreams/list${QS.query(
      QS.explode({
        site_accure_id: siteAccureId,
      }),
    )}`,
    {
      ...opts,
    },
  );
}
/**
 * Create a new workstream, optionally using a predefined template
 */
export function tasksV1WorkstreamsNewCreate(
  {
    createWorkstreamViewInputRequest,
  }: {
    createWorkstreamViewInputRequest: CreateWorkstreamViewInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateWorkstreamViewOutput;
      }
    | {
        status: 400;
      }
  >(
    '/tasks/v1/workstreams/new',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createWorkstreamViewInputRequest,
    }),
  );
}
/**
 * Download ISO 27001 Information Security Management System certificate
 */
export function trustCenterCertificatesIso27001Retrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 404;
      }
  >('/trust-center/certificates/iso-27001', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Download ISO 27001 Statement of Applicability document
 */
export function trustCenterCertificatesIso27001SoaRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchBlob<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 404;
      }
  >('/trust-center/certificates/iso-27001-soa', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Update user preferences (name and/or default landing page)
 */
export function usersV1PreferencesPartialUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    userUuid,
    patchedUpdateUserPreferencesInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    userUuid: string;
    patchedUpdateUserPreferencesInputRequest?: PatchedUpdateUserPreferencesInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: AuthUser;
      }
    | {
        status: 422;
      }
  >(
    `/users/v1/${encodeURIComponent(userUuid)}/preferences`,
    oazapfts.json({
      ...opts,
      method: 'PATCH',
      body: patchedUpdateUserPreferencesInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Create a new Auth0 user with corresponding database entry
 */
export function usersV1Auth0CreateCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createAuth0UserRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createAuth0UserRequest: CreateAuth0UserRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateAuth0UserOutput;
      }
    | {
        status: 422;
      }
  >(
    '/users/v1/auth0/create',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createAuth0UserRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Delete an Auth0 user from all systems (Auth0, Looker, and database). Provide either uuid or email to identify the user.
 */
export function usersV1Auth0DeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DeleteAuth0UserOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
    | {
        status: 424;
      }
  >('/users/v1/auth0/delete', {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * List all auth users with pagination support
 */
export function usersV1Auth0ListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    limit,
    offset,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    limit: number;
    offset: number;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListAuthUsersOutputRead;
      }
    | {
        status: 422;
      }
  >(
    `/users/v1/auth0/list${QS.query(
      QS.explode({
        limit,
        offset,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Retrieve list of looker users
 */
export function usersV1ListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: ListAllUsersViewOutput;
      }
    | {
        status: 422;
      }
  >('/users/v1/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Retrieve list of looker users
 */
export function usersV1LookerListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListLookerUsersViewOutput;
      }
    | {
        status: 422;
      }
  >('/users/v1/looker/list', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Sync looker users
 */
export function usersV1LookerUpdateCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText('/users/v1/looker/update', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Get current user information based on authentication headers
 */
export function usersV1MeRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: MeViewOutput;
      }
    | {
        status: 404;
      }
  >('/users/v1/me', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Request an MFA enrollment ticket URL from Auth0 Management API
 */
export function usersV1MfaEnrollCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: RequestMfaEnrollmentTicketOutput;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >('/users/v1/mfa/enroll', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Remove MFA enrollment for the current user
 */
export function usersV1MfaUnenrollDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: RemoveMfaEnrollmentOutput;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >('/users/v1/mfa/unenroll', {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Create a new non-looker user
 */
export function usersV1NewUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createUserInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createUserInputRequest: CreateUserInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: User;
      }
    | {
        status: 422;
      }
  >(
    '/users/v1/new',
    oazapfts.json({
      ...opts,
      method: 'PUT',
      body: createUserInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Request a password reset ticket URL from Auth0 Management API
 */
export function usersV1PasswordResetCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: RequestPasswordResetOutput;
      }
    | {
        status: 422;
      }
    | {
        status: 500;
      }
  >('/users/v1/password-reset', {
    ...opts,
    method: 'POST',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Delete a role by UUID
 */
export function usersV1RolesDeleteDestroy(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    roleUuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    roleUuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: DeleteRoleOutput;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(`/users/v1/roles/${encodeURIComponent(roleUuid)}/delete`, {
    ...opts,
    method: 'DELETE',
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
    }),
  });
}
/**
 * Update an existing role
 */
export function usersV1RolesUpdatePartialUpdate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    roleUuid,
    patchedUpdateRoleInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    roleUuid: string;
    patchedUpdateRoleInputRequest?: PatchedUpdateRoleInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: RoleRead;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
      }
  >(
    `/users/v1/roles/${encodeURIComponent(roleUuid)}/update`,
    oazapfts.json({
      ...opts,
      method: 'PATCH',
      body: patchedUpdateRoleInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * Create a new Role
 */
export function usersV1RolesCreateCreate(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    createRoleInputRequest,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    createRoleInputRequest: CreateRoleInputRequest;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 201;
        data: CreateRoleOutput;
      }
    | {
        status: 422;
      }
  >(
    '/users/v1/roles/create',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body: createRoleInputRequest,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    }),
  );
}
/**
 * List all roles with pagination support
 */
export function usersV1RolesListRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    limit,
    offset,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    limit: number;
    offset: number;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListRolesOutputRead;
      }
    | {
        status: 422;
      }
  >(
    `/users/v1/roles/list${QS.query(
      QS.explode({
        limit,
        offset,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get warranty penalties data for units
 */
export function warrantyV1PenaltiesRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    aggregationLevel,
    customerType,
    dataType,
    endTime,
    siteId,
    startTime,
    topId,
    unitId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    aggregationLevel?:
      | 'array'
      | 'bank'
      | 'cell'
      | 'container'
      | 'module'
      | 'node'
      | 'pack'
      | 'system';
    customerType: 'bess' | 'hss' | 'mobility';
    dataType: 'chart' | 'overview' | 'timeseries';
    endTime?: string;
    siteId?: string;
    startTime?: string;
    topId?: string;
    unitId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: WarrantyPenaltiesViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v1/penalties/${QS.query(
      QS.explode({
        aggregation_level: aggregationLevel,
        customer_type: customerType,
        data_type: dataType,
        end_time: endTime,
        site_id: siteId,
        start_time: startTime,
        top_id: topId,
        unit_id: unitId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get warranty status data for units
 */
export function warrantyV1StatusRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    aggregationLevel,
    customerType,
    siteId,
    topId,
    unitId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    aggregationLevel?:
      | 'array'
      | 'bank'
      | 'cell'
      | 'container'
      | 'module'
      | 'node'
      | 'pack'
      | 'system';
    customerType: 'bess' | 'hss' | 'mobility';
    siteId?: string;
    topId?: string;
    unitId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: WarrantyStatusViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v1/status/${QS.query(
      QS.explode({
        aggregation_level: aggregationLevel,
        customer_type: customerType,
        site_id: siteId,
        top_id: topId,
        unit_id: unitId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get timeseries data for a specific system
 */
export function warrantyV1SystemTimeseriesRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    customerType,
    endTime,
    metrics,
    siteId,
    startTime,
    systemId,
    topId,
    unitId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    customerType: 'bess' | 'hss' | 'mobility';
    endTime: string;
    metrics: string[];
    siteId?: string;
    startTime: string;
    systemId: string;
    topId?: string;
    unitId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: TimeseriesOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v1/system/${encodeURIComponent(systemId)}/timeseries/${QS.query(
      QS.explode({
        customer_type: customerType,
        end_time: endTime,
        metrics,
        site_id: siteId,
        start_time: startTime,
        top_id: topId,
        unit_id: unitId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get warranty violations data for units
 */
export function warrantyV1ViolationsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    aggregationLevel,
    customerType,
    endTime,
    siteId,
    startTime,
    topId,
    unitId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    aggregationLevel?:
      | 'array'
      | 'bank'
      | 'cell'
      | 'container'
      | 'module'
      | 'node'
      | 'pack'
      | 'system';
    customerType: 'bess' | 'hss' | 'mobility';
    endTime?: string;
    siteId?: string;
    startTime?: string;
    topId?: string;
    unitId?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: WarrantyViolationsViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v1/violations/${QS.query(
      QS.explode({
        aggregation_level: aggregationLevel,
        customer_type: customerType,
        end_time: endTime,
        site_id: siteId,
        start_time: startTime,
        top_id: topId,
        unit_id: unitId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get comprehensive warranty data including unit overview, penalties, and condition violations
 */
export function warrantyV2DataRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    arrayId,
    bankId,
    containerId,
    moduleId,
    nodeId,
    packId,
    systemId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    arrayId?: string;
    bankId?: string;
    containerId?: string;
    moduleId?: string;
    nodeId?: string;
    packId?: string;
    systemId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: WarrantyDataViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v2/data/${QS.query(
      QS.explode({
        array_id: arrayId,
        bank_id: bankId,
        container_id: containerId,
        module_id: moduleId,
        node_id: nodeId,
        pack_id: packId,
        system_id: systemId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Download warranty metrics data for a specific system as CSV
 */
export function warrantyV2DownloadMetricsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    metricGroup,
    systemId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    metricGroup: string;
    systemId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: Blob;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v2/download-metrics/${QS.query(
      QS.explode({
        metric_group: metricGroup,
        system_id: systemId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get available ID filters for a specific system
 */
export function warrantyV2FiltersRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    arrayId,
    bankId,
    containerId,
    moduleId,
    nodeId,
    packId,
    systemId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    arrayId?: string;
    bankId?: string;
    containerId?: string;
    moduleId?: string;
    nodeId?: string;
    packId?: string;
    systemId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: ListWarrantyFiltersViewOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 404;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v2/filters/${QS.query(
      QS.explode({
        array_id: arrayId,
        bank_id: bankId,
        container_id: containerId,
        module_id: moduleId,
        node_id: nodeId,
        pack_id: packId,
        system_id: systemId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Get warranty metrics data for a specific system. If finding_type is provided, only metrics for that specific finding type will be returned. Otherwise, all warranty metrics (SOH, Availability, RTE) will be returned.
 */
export function warrantyV2MetricsRetrieve(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    findingType,
    systemId,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    findingType?:
      | 'warranty_rte'
      | 'warranty_soh'
      | 'warranty_tag'
      | 'warranty_tag_pcs';
    systemId: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: MetricsOutput;
      }
    | {
        status: 400;
      }
    | {
        status: 422;
        data: {
          /** The error message describing the validation issue. */
          error?: string;
        };
      }
    | {
        status: 500;
      }
  >(
    `/warranty/v2/metrics/${QS.query(
      QS.explode({
        finding_type: findingType,
        system_id: systemId,
      }),
    )}`,
    {
      ...opts,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
      }),
    },
  );
}
/**
 * Chat with Curie chatbot
 */
export function rawStreamViewPost(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    xUserContextPage,
    xUserContextFilters,
    body,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    xUserContextPage?: string;
    xUserContextFilters?: string;
    body: {
      /** The prompt to send to the AI model. */
      prompt: string;
    };
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    '/ai/v1/curie/reply',
    oazapfts.json({
      ...opts,
      method: 'POST',
      body,
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
        'X-User-Context-Page': xUserContextPage,
        'X-User-Context-Filters': xUserContextFilters,
      }),
    }),
  );
}
/**
 * Summarize a document
 */
export function documentSummaryPost(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    xUserContextPage,
    xUserContextFilters,
    documentUuid,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    xUserContextPage?: string;
    xUserContextFilters?: string;
    documentUuid: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchText(
    `/ai/v1/curie/${encodeURIComponent(documentUuid)}/summarize`,
    {
      ...opts,
      method: 'POST',
      headers: oazapfts.mergeHeaders(opts?.headers, {
        'X-USER-COMPANY': xUserCompany,
        'X-USER-EMAIL': xUserEmail,
        'X-USER-NAME': xUserName,
        'X-User-Context-Page': xUserContextPage,
        'X-User-Context-Filters': xUserContextFilters,
      }),
    },
  );
}
/**
 * Get chat history
 */
export function chatHistoryGet(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    xUserContextPage,
    xUserContextFilters,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    xUserContextPage?: string;
    xUserContextFilters?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<{
    status: 200;
    data: {
      /** List of messages in the conversation history, alternating between user prompts and AI responses */
      chat_history?: string[];
    };
  }>('/ai/v1/curie/chat-history', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
      'X-User-Context-Page': xUserContextPage,
      'X-User-Context-Filters': xUserContextFilters,
    }),
  });
}
/**
 * Get predefined prompts
 */
export function getPrompts(
  {
    xUserCompany,
    xUserEmail,
    xUserName,
    xUserContextPage,
    xUserContextFilters,
  }: {
    xUserCompany?: string;
    xUserEmail?: string;
    xUserName?: string;
    xUserContextPage?: string;
    xUserContextFilters?: string;
  },
  opts?: Oazapfts.RequestOpts,
) {
  return oazapfts.fetchJson<
    | {
        status: 200;
        data: {
          prompts?: {
            /** Available command keywords and their descriptions */
            commands?: object;
            /** Example questions that can be asked */
            questions?: string[];
          };
        };
      }
    | {
        status: 500;
        data: {
          error?: string;
        };
      }
  >('/ai/v1/curie/prompts', {
    ...opts,
    headers: oazapfts.mergeHeaders(opts?.headers, {
      'X-USER-COMPANY': xUserCompany,
      'X-USER-EMAIL': xUserEmail,
      'X-USER-NAME': xUserName,
      'X-User-Context-Page': xUserContextPage,
      'X-User-Context-Filters': xUserContextFilters,
    }),
  });
}
